import PropTypes from 'prop-types';
import { BsCheckCircle, BsClock, BsCursor, BsEnvelopeOpen, BsXCircle } from 'react-icons/bs';

import { StatCard } from '../common/CampaignStatsCards/CampaignStatsCards';

const EmailSendStatCards = ({ stats }) => (
	<div className="grid grid-cols-2 md:grid-cols-5 gap-4">
		<StatCard
			title="Geplant"
			value={stats.scheduled ?? 0}
			icon={BsClock}
			iconColor="text-caution-700"
			bgColor="bg-caution-200"
		/>
		<StatCard
			title="Gesendet"
			value={stats.sent ?? 0}
			icon={BsCheckCircle}
			iconColor="text-success-700"
			bgColor="bg-success-200"
		/>
		<StatCard
			title="Fehlgeschlagen"
			value={stats.failed ?? 0}
			icon={BsXCircle}
			iconColor="text-warning-700"
			bgColor="bg-warning-200"
		/>
		<StatCard
			title="Öffnungsrate"
			value={`${stats.openRate ?? '0.0'}%`}
			icon={BsEnvelopeOpen}
			iconColor="text-primary-700"
			bgColor="bg-primary-200"
		/>
		<StatCard
			title="Klickrate"
			value={`${stats.clickRate ?? '0.0'}%`}
			icon={BsCursor}
			iconColor="text-primary-600"
			bgColor="bg-primary-200"
		/>
	</div>
);

EmailSendStatCards.propTypes = {
	stats: PropTypes.shape({
		scheduled: PropTypes.number,
		sent: PropTypes.number,
		failed: PropTypes.number,
		openRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		clickRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}).isRequired,
};

export default EmailSendStatCards;
